import { Injectable } from '@angular/core';
import { LoginResponseData } from '../models/responses/login-response-data';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  loginResponseData!:LoginResponseData ;
  
  constructor() { }
}
